/* ============================================================
   SHAKSHI GROUP — Global JavaScript (sg-global.js)
   Scroll reveal, sticky header, mobile menu, smooth scroll, tracking
   ============================================================ */

document.addEventListener('DOMContentLoaded', () => {

  /* --- Scroll Reveal (Intersection Observer) --- */
  const revealElements = document.querySelectorAll('.sg-reveal');
  if (revealElements.length > 0 && 'IntersectionObserver' in window) {
    const revealObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const delay = parseInt(entry.target.style.getPropertyValue('--sg-i') || '0') * 120;
          setTimeout(() => {
            entry.target.classList.add('sg-revealed');
          }, delay);
          revealObserver.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.15,
      rootMargin: '0px 0px -60px 0px'
    });

    revealElements.forEach(el => revealObserver.observe(el));
  }

  /* --- Smooth Scroll for Anchor Links --- */
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  /* --- Conversion Tracking Hooks --- */
  document.querySelectorAll('[data-sg-track]').forEach(el => {
    el.addEventListener('click', function() {
      const action = this.getAttribute('data-sg-track');
      if (typeof gtag === 'function') {
        gtag('event', 'sg_cta_click', {
          event_category: 'B2B Conversion',
          event_label: action,
          transport_type: 'beacon'
        });
      }
      // console.log('[SG Track]', action);
    });
  });

});

/* --- CSS for Scroll Reveal --- */
(function() {
  const style = document.createElement('style');
  style.textContent = `
    .sg-reveal {
      opacity: 0;
      transform: translateY(32px);
      transition: opacity 0.8s cubic-bezier(0.22, 1, 0.36, 1),
                  transform 0.8s cubic-bezier(0.22, 1, 0.36, 1);
    }
    .sg-revealed {
      opacity: 1;
      transform: translateY(0);
    }
  `;
  document.head.appendChild(style);
})();
